import React, { Component } from 'react';
import L from '../services/localizationService';

class CurrencyInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            key: props.state,
            value: props.value,
            onChanged: props.onChanged,

            isEditing: false
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.exitControl();
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState( { value: this.props.value })
        }
    }
      
    changeData(newValue) {
        this.setState({
            value: newValue
        });
    }

    enterControl() {
        this.setState({
        isEditing: true,
        value: parseFloat(this.state.value) === 0 ? '' : this.state.value
        })
    }

    exitControl() {
        if (this.state.isEditing) {
            let newValue = this.state.value.replace(/[^0-9.-]/g, '');
            this.state.onChanged(newValue);

            this.setState({
                isEditing: false,
                value: newValue
            })
        }
    }

    getValue() {
        let valueToReturn = this.state.value;
        if (!this.state.isEditing) {
            valueToReturn = L.toCurrencyString(this.state.value);
        }

        return valueToReturn;
    }

    render() {
        return <input key={this.state.key} 
            value={this.getValue()}
            onFocus={(e) => {this.enterControl()}}
            onChange={(e) => {this.changeData(e.target.value)}}
            onBlur={(e) => {this.exitControl()}}>
        </input>
    }
}

export default CurrencyInput;
